import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b433fc8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ft-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-title"
}, "会员开通", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-placeholder"
}, null, -1));
const _hoisted_4 = {
  class: "ft-balance"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bal-label"
}, "我的鲸豆余额", -1));
const _hoisted_6 = {
  class: "bal-num"
};
const _hoisted_7 = {
  key: 0,
  class: "bal-status"
};
const _hoisted_8 = {
  key: 1,
  class: "bal-status"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft-section-title"
}, "选择会员时长", -1));
const _hoisted_10 = {
  class: "ft-list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "card-left"
};
const _hoisted_13 = {
  class: "card-name-row"
};
const _hoisted_14 = {
  class: "card-name"
};
const _hoisted_15 = {
  key: 0,
  class: "card-tag"
};
const _hoisted_16 = {
  key: 1,
  class: "card-tag tag-best"
};
const _hoisted_17 = {
  class: "card-day"
};
const _hoisted_18 = {
  class: "card-right"
};
const _hoisted_19 = {
  class: "card-price"
};
const _hoisted_20 = {
  class: "card-daily"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "card-arrow"
}, "›", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft-notice"
}, [/*#__PURE__*/_createElementVNode("p", null, "📌 使用鲸豆兑换会员时长，开通后即时生效"), /*#__PURE__*/_createElementVNode("p", null, "到期时间可在\"我的\"页面查看")], -1));
import { ref, computed, onMounted, createVNode } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { showNotify, showDialog } from '@nutui/nutui';
import service from '@/utils/request';
import request from '@/utils/request';
import moment from 'moment';
export default {
  __name: 'FullTimeView',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const successNotify = msg => {
      showNotify.success(msg, {
        duration: 2000
      });
    };

    // 鲸豆余额：computed 跟随 store，购买后 getInfo 刷新自动更新
    const balance = computed(() => store.state.user?.beans ?? 0);
    // 会员有效期：moment 格式化
    const memberEnd = computed(() => store.state.fullUser && store.state.user?.endDate ? moment(store.state.user.endDate).format('YYYY-MM-DD') : '未开通');
    const cardList = ref([]);
    const getTimeList = () => {
      request.get('/getCardList').then(res => {
        if (res.code == 200) {
          cardList.value = res.cardList;
        } else {
          timeNotify(res.msg);
        }
      });
    };

    // 日均价
    const dailyPrice = card => (card.amount / card.day).toFixed(2);
    const goBack = () => {
      router.back();
    };
    const goRecharge = () => {
      router.push('/recharge');
    };
    const baseClick = card => {
      const content = createVNode('div', {
        style: {
          textAlign: 'center',
          padding: '8px 0'
        }
      }, [createVNode('div', {
        style: {
          fontSize: '17px',
          fontWeight: '700',
          color: '#333'
        }
      }, `开通「${card.name}」会员`), createVNode('div', {
        style: {
          color: '#999',
          fontSize: '13px',
          margin: '6px 0'
        }
      }, `会员时长 ${card.day} 天`), createVNode('div', {
        style: {
          fontSize: '14px',
          color: '#555'
        }
      }, ['将消耗 ', createVNode('span', {
        style: {
          color: '#22c1c3',
          fontWeight: '700'
        }
      }, `${card.amount} 鲸豆`), '，是否确认购买？'])]);
      showDialog({
        title: '购买确认',
        content,
        onOk: () => {
          onOk(card);
        }
      });
    };
    const onOk = card => {
      openCard(card.cardId);
    };
    const openCard = async cardId => {
      const response = await service.post('/openCard', {
        cardId: cardId
      });
      if (response.code == 200) {
        successNotify("购买成功");
        getInfo();
      } else {
        timeNotify(response.msg);
      }
    };
    const getInfo = () => {
      request.get('/getInfo').then(res => {
        if (res.code == 200) {
          store.dispatch('login', res);
        }
      });
    };
    onMounted(getTimeList);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "ft-navbar"
      }, [_createElementVNode("span", {
        class: "back-btn",
        onClick: goBack
      }, "← 返回"), _hoisted_2, _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        class: "bal-recharge",
        onClick: goRecharge
      }, "充值"), _hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(balance.value), 1), memberEnd.value !== '未开通' ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 会员有效期至 " + _toDisplayString(memberEnd.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂未开通会员，开通后解锁 AI 分析等高级功能 "))]), _hoisted_9, _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, card => {
        return _openBlock(), _createElementBlock("div", {
          class: "ft-card",
          key: card.cardId,
          onClick: $event => baseClick(card)
        }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(card.name), 1), card.name === '月卡' ? (_openBlock(), _createElementBlock("span", _hoisted_15, "热销")) : _createCommentVNode("", true), card.name === '年卡' ? (_openBlock(), _createElementBlock("span", _hoisted_16, "最划算")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, _toDisplayString(card.day) + "天会员", 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, "¥" + _toDisplayString(card.amount), 1), _createElementVNode("div", _hoisted_20, "≈ ¥" + _toDisplayString(dailyPrice(card)) + "/天", 1)]), _hoisted_21], 8, _hoisted_11);
      }), 128))]), _hoisted_22]);
    };
  }
};